import React from "react";
import _ from "lodash";
import Modal from "Components/smallModal/smallModal";
import Input from "Components/input/Input";
import Loader from "Components/loader/Loader";
import Button from "Components/button/Button";
import Checkbox from "Components/checkbox/Checkbox";
import WarningBanner from "Components/warningBanner/WarningBanner";
import TranslatedString from "Components/TranslatedString";
import RadioButton from "Components/radiobutton/RadioButton";
import QuotaSelector from "Components/quotaSelector/QuotaSelector";
import { t } from "i18next";
import cx from "classnames";
import s from "./generals.scss";
import Toggle from "Components/toggle/Toggle";
import { quotas, humanQuotas } from "../../../config";
import { Trans } from "react-i18next";

export default class Generals extends React.Component {
  constructor(props) {
    super(props);

    this.alertIfIsPaidOption = this.alertIfIsPaidOption.bind(this);
    this.openWarnModal = this.openWarnModal.bind(this);
    this.closeWarnModal = this.closeWarnModal.bind(this);

    this.state = {
      initialPlan: props.domain.plan.name,

      inputsDisabled: false,
      viewFields: [
        "max_email_accounts",
        "max_email_accounts_archive",
        "max_email_accounts_25gb",
        "max_email_accounts_50gb",
        "max_email_accounts_100gb",
        "max_email_quota",
        "default_quota",
        "default_quota_apply_to_all",
        "outbound_limit",
        "pop_disabled",
        "imap_disabled",
        "smtp_disabled",
        "webmail_disabled",
        "activesync",
        "dav",
        "chat",
        "meeting",

        "plan",
        "catch_all_destination",
        "catch_all_enabled",
        // Extra plan features
        "extra_mailbox_50gb",
        "extra_mailbox_100gb",
      ],
      isWarnModalOpened: false,
      isUpgradeModalOpened: false,
      warnModalType: null,
      outboundLimitValue: null,
      isWarnPlanModalOpened: false,
      isCantDowngradeBasicOpened: false,
    };
  }

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  closeCantDowngradeBasic = () => this.setState({ isCantDowngradeBasicOpened: false });
  openCantDowngradeBasic = () => this.setState({ isCantDowngradeBasicOpened: true });
  closeWarnPlanModal = () => this.setState({ isWarnPlanModalOpened: false, warnModalType: null });
  openWarnPlanModal = (type) => this.setState({ isWarnPlanModalOpened: true, warnModalType: type });
  closeUpgradePlanModal = () => this.setState({ isUpgradePlanModalOpened: false, upgradeModalType: null });
  openUpgradePlanModal = (type) => this.setState({ isUpgradePlanModalOpened: true, upgradeModalType: type });

  openWarnModal(val) {
    this.setState({ isWarnModalOpened: true, outboundLimitValue: val });
  }

  closeWarnModal() {
    this.props.setFormFieldValue({ outbound_limit: this.state.outboundLimitValue });

    this.setState({
      isWarnModalOpened: false,
      paidOptionSelected: true,
      outboundLimitValue: null,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFormLoading && !this.props.isFormLoading) {
      this.setState({ initialPlan: this.props.domain.plan.name });
    }
  }

  setMaxEmailAccountsValue(value) {
    const { formData, setFormFieldValue } = this.props;
    let fieldsToChange = {};
    if (parseInt(value.max_email_accounts) < parseInt(formData.max_email_accounts_archive)) {
      fieldsToChange.max_email_accounts_archive = value.max_email_accounts;
    }

    setFormFieldValue({ ...value, ...fieldsToChange });
  }

  setMaxEmailQuotaValue = (value) => {
    const { formData, setFormFieldValue } = this.props;
    let maxQuota = parseInt(value.max_email_quota);
    let defaultQuota = parseInt(formData.default_quota);
    let fieldsToChange = {};
    if (maxQuota < defaultQuota) {
      fieldsToChange.default_quota = value.max_email_quota;
    }

    // auto-set value of limits on email accounts based on the new quota
    if (maxQuota < humanQuotas["100GB"]) {
      fieldsToChange.max_email_accounts_100gb = 0;
    }

    if (maxQuota < humanQuotas["50GB"]) {
      fieldsToChange.max_email_accounts_50gb = 0;
    }

    if (maxQuota < humanQuotas["16GB"]) {
      fieldsToChange.max_email_accounts_25gb = 0;
    }

    setFormFieldValue({ ...value, ...fieldsToChange });
  };

  formatOutboundLimits(outboundLimits) {
    let defaultOption = null;

    let outboundLimitOptions = _.compact(
      outboundLimits.map((limit) => {
        const paymentOptionLabel = limit.pay > 0 ? <code>{t("input.hint.paid.option")}</code> : null;
        const defaultOptionLabel =
          limit.description === "default" ? <code>{t("input.hint.default.option")}</code> : null;

        const data = {
          value: limit.id,
          label: (
            <TranslatedString
              subs={{
                msgNumber: limit.rate,
                hours: limit.period / 3600,
              }}
              components={{
                OptionTag: paymentOptionLabel || defaultOptionLabel || <></>,
              }}
            >
              input.label.sentMsg24h
            </TranslatedString>
          ),
          rate: limit.rate,
        };

        if (limit.description === "default") {
          defaultOption = data;
          return null;
        }

        return data;
      })
    );

    outboundLimitOptions = _.sortBy(outboundLimitOptions, ["rate"]);
    outboundLimitOptions.unshift(defaultOption);
    return outboundLimitOptions;
  }

  alertIfIsPaidOption(values) {
    let val = parseInt(values.outbound_limit, 10);
    const isAPaidOption = !!this.props.outboundLimits.filter((limit) => limit.id === val && limit.pay)[0];

    if (isAPaidOption) {
      this.openWarnModal(val);
    } else {
      this.setState({
        paidOptionSelected: false,
      });
      this.props.setFormFieldValue({ outbound_limit: val });
    }
  }

  setPlan = (v) => {
    const { initialPlan } = this.state;
    const { domain } = this.props;

    const isDowngradingToBasic = initialPlan !== "basic" && v.plan === "basic";
    const isDowngradingToProfessional = initialPlan === "enterprise" && v.plan === "professional";

    const isUpgradingToProfessional = initialPlan === "basic" && v.plan === "professional";
    const isUpgradingToEnterprise = initialPlan !== "enterprise" && v.plan === "enterprise";

    if (isDowngradingToBasic && !domain.can_downgrade_to_basic) {
      this.openCantDowngradeBasic();
      return;
    }

    // handle extra features properly based on the plan
    if (this.props.isLoggedUserAdmin) {
      if (isUpgradingToProfessional) {
        // unset & disabled 50gb as an extra feature, because is in the plan
        this.props.setFormFieldValue({ extra_mailbox_50gb: false });
      }

      if (isUpgradingToEnterprise) {
        // unset & disabled 50gb as an extra feature, because is in the plan
        this.props.setFormFieldValue({ extra_mailbox_100gb: false, extra_mailbox_50gb: false });
      }
    }

    if (isUpgradingToProfessional) {
      this.openUpgradePlanModal("professional");
    } else if (isUpgradingToEnterprise) {
      this.openUpgradePlanModal("enterprise");
    } else if (isDowngradingToBasic) {
      this.openWarnPlanModal("basic");
    } else if (isDowngradingToProfessional) {
      this.openWarnPlanModal("professional");
    } else {
      this.props.setFormFieldValue(v);
    }
  };

  confirmDowngradePlan = () => {
    this.props.setFormFieldValue({ plan: this.state.warnModalType });
    this.closeWarnPlanModal();
  };

  confirmUpgradePlan = () => {
    this.props.setFormFieldValue({ plan: this.state.upgradeModalType });
    this.closeUpgradePlanModal();
  };

  render() {
    const {
      isLoggedUserInTrial,
      isLoggedUserAdmin,
      isDomainLoading,
      formData,
      formErrors,
      setFormFieldValue,
      submitForm,
      isFormLoading,
      outboundLimits,
      isLoggedUserTrial,
      loggedUser,
      hasloggedUserCatchallEnabled,
      domain: {
        plan: { features },
      },
    } = this.props;

    if (isDomainLoading) {
      return <Loader />;
    }

    const annualOrder = loggedUser.orders?.[0]?.billing_cycle === "annually";

    let isWaitingPayment = loggedUser.type === "Customer" && loggedUser.status_detail === "wait_pay";

    let disabledDefaultQuotas = [];
    quotas.forEach((q) => {
      if (q.value > parseInt(formData.max_email_quota)) {
        disabledDefaultQuotas.push(q.value);
      }
    });

    // Format outbound limits
    const areOutboundLimitsLoading = Object.keys(outboundLimits).length === 0;
    let outboundLimitOptions;
    if (!areOutboundLimitsLoading) {
      outboundLimitOptions = this.formatOutboundLimits(outboundLimits);
    }

    // Catch all message
    let disabledCatchAllMessage = "";
    if (!hasloggedUserCatchallEnabled) {
      if (isLoggedUserAdmin) {
        disabledCatchAllMessage = <WarningBanner msg={t("infoMsg.catchAllDisabledAdmin")} />;
      } else {
        disabledCatchAllMessage = <WarningBanner msg={t("infoMsg.catchAllDisabled")} />;
      }
    }

    let canEditPlans = false;
    if (isLoggedUserAdmin | (loggedUser.type === "Customer") || loggedUser.type === "TeamMember") {
      canEditPlans = true;
    }

    return (
      <form className={s.general} method="post" onSubmit={(e) => submitForm(e, this.state.viewFields)}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine(...this.state.viewFields) && !formErrors.onForm && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}

            {formErrors.onForm && (
              <div className="inputFull2">
                <WarningBanner msg={formErrors.onForm} color="red" />
              </div>
            )}
          </div>
          <div className={s.infoBtnGroup}>
            <Button docsKey="domains_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>

        <div className={s.settings}>
          {canEditPlans && (
            <div className="sectionSP">
              <div className="infoSectionSP">
                <div className="settingTitle">{t("settings.sections.planManagement.title")}</div>
                <div className="sectionDesc">{t("settings.sections.planManagement.desc")}</div>
              </div>
              <div className="formsSectionSP">
                {annualOrder && (
                  <div className="inputFull2">
                    <WarningBanner msg={"Vai in ordini per eseguire l'upgrade del piano"} />
                  </div>
                )}

                <RadioButton
                  className="inputFull2"
                  grouplabel={t("input.label.select.plan")}
                  children={[
                    {
                      value: "basic",
                      label: t("plan.basic.name"),
                      description: t("plan.basic.desc"),
                      disabled: annualOrder,
                    },
                    {
                      value: "professional",
                      label: t("plan.professional.name"),
                      description: t("plan.professional.desc"),
                      bestLabel: t("plan.professional.bestLabel"),
                      disabled: annualOrder,
                    },
                    {
                      value: "enterprise",
                      label: t("plan.enterprise.name"),
                      description: t("plan.enterprise.desc"),
                      disabled: annualOrder,
                    },
                  ]}
                  name="plan"
                  value={formData.plan}
                  onChange={this.setPlan}
                />
              </div>
            </div>
          )}

          {isLoggedUserAdmin && (
            <div className="sectionSP">
              <div className="infoSectionSP">
                <div className="settingTitle">Gestione features extra piano</div>
                <div className="sectionDesc">
                  Come admin, puoi aggiungere alcuni permessi speciali a questo dominio indipendentemente dal piano
                </div>
              </div>
              <div className="formsSectionSP">
                <Toggle
                  className="inputFull2"
                  label={"Aggiungi opzione 50GB al piano Basic"}
                  name="extra_mailbox_50gb"
                  checked={formData.extra_mailbox_50gb}
                  errors={formErrors.extra_mailbox_50gb}
                  onChange={setFormFieldValue}
                  disabled={formData.plan !== "basic"}
                />

                <Toggle
                  className="inputFull2"
                  label={"Aggiungi opzione 100GB (indipendentemente dal piano)"}
                  name="extra_mailbox_100gb"
                  checked={formData.extra_mailbox_100gb}
                  errors={formErrors.extra_mailbox_100gb}
                  onChange={setFormFieldValue}
                  disabled={formData.plan === "enterprise"}
                />
              </div>
            </div>
          )}

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("input.label.maxAccountsSize")}</div>
              <div className="sectionDesc">{t("settings.sections.domains.maxAccountSize")}</div>
            </div>
            <div className="formsSectionSP">
              <div className="inputFull2">
                <WarningBanner info color="blue" msg={<TranslatedString>infoMsg.maxQuota</TranslatedString>} />
              </div>

              <QuotaSelector
                className="inputFull2"
                onChange={this.setMaxEmailQuotaValue}
                value={formData.max_email_quota}
                name="max_email_quota"
                errors={formErrors.max_email_quota}
                disabled={this.state.inputsDisabled || isLoggedUserInTrial}
                hideUpgradeL={!features.mailbox_50gb}
                hideUpgradeXL={!features.mailbox_100gb}
              />
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("input.label.accountsDefaultQuota")}</div>
              <div className="sectionDesc">{t("settings.sections.domains.maxAccountSize")}</div>
            </div>
            <div className="formsSectionSP">
              <QuotaSelector
                className="inputFull2"
                name="default_quota"
                value={formData.default_quota}
                errors={formErrors.default_quota}
                disabled={isLoggedUserInTrial}
                onChange={setFormFieldValue}
                disabledQuotas={disabledDefaultQuotas}
                hideUpgradeL={!features.mailbox_50gb}
                hideUpgradeXL={!features.mailbox_100gb}
              />
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.domain.limits.title")}</div>
              <div className="sectionDesc">{t("settings.sections.domain.limits.desc")}</div>
            </div>
            <div className="formsSectionSP">
              {formErrors.onForm && (
                <div className="inputFull2">
                  <WarningBanner msg={formErrors.onForm} color="red" />
                </div>
              )}

              <Input
                ref={(input) => (this.firstInput = input)}
                name="max_email_accounts"
                type="number"
                label={t("input.label.maxAccountsAvailable8")}
                min={-1}
                value={formData.max_email_accounts}
                errors={formErrors.max_email_accounts}
                onChange={this.setMaxEmailAccountsValue.bind(this)}
                step={1}
                disabled={this.state.inputsDisabled || isLoggedUserInTrial || annualOrder}
                required
              />

              <Input
                name="max_email_accounts_25gb"
                type="number"
                label={t("input.label.maxAccountsAvailable25")}
                min={-1}
                max={formData.max_email_accounts === -1 ? 999999999 : formData.max_email_accounts}
                step={1}
                value={formData.max_email_accounts_25gb}
                errors={formErrors.max_email_accounts_25gb}
                disabled={
                  this.state.inputsDisabled ||
                  isLoggedUserInTrial ||
                  annualOrder ||
                  formData.max_email_quota < humanQuotas["16GB"]
                }
                onChange={setFormFieldValue}
                required
              />

              {features.mailbox_50gb && (
                <Input
                  name="max_email_accounts_50gb"
                  type="number"
                  label={t("input.label.maxAccountsAvailable50")}
                  min={-1}
                  max={formData.max_email_accounts === -1 ? 999999999 : formData.max_email_accounts}
                  step={1}
                  value={formData.max_email_accounts_50gb}
                  errors={formErrors.max_email_accounts_50gb}
                  disabled={
                    this.state.inputsDisabled ||
                    isLoggedUserInTrial ||
                    annualOrder ||
                    formData.max_email_quota < humanQuotas["50GB"]
                  }
                  onChange={setFormFieldValue}
                  required
                />
              )}

              {features.mailbox_100gb && (
                <Input
                  name="max_email_accounts_100gb"
                  type="number"
                  label={t("input.label.maxAccountsAvailable100")}
                  min={-1}
                  max={formData.max_email_accounts === -1 ? 999999999 : formData.max_email_accounts}
                  step={1}
                  value={formData.max_email_accounts_100gb}
                  errors={formErrors.max_email_accounts_100gb}
                  disabled={
                    this.state.inputsDisabled ||
                    isLoggedUserInTrial ||
                    annualOrder ||
                    formData.max_email_quota < humanQuotas["100GB"]
                  }
                  onChange={setFormFieldValue}
                  required
                />
              )}

              <Input
                name="max_email_accounts_archive"
                type="number"
                label={t("input.label.maxArchiveAvailable")}
                min={-1}
                max={formData.max_email_accounts === -1 ? 999999999 : formData.max_email_accounts}
                step={1}
                value={formData.max_email_accounts_archive}
                errors={formErrors.max_email_accounts_archive}
                disabled={this.state.inputsDisabled || isLoggedUserInTrial || annualOrder}
                onChange={setFormFieldValue}
                required
              />

              <Checkbox
                className="inputFull2"
                label={<TranslatedString>input.label.applyDefaultQuotaToAll</TranslatedString>}
                name="default_quota_apply_to_all"
                value={formData.default_quota_apply_to_all}
                errors={formErrors.default_quota_apply_to_all}
                onChange={setFormFieldValue}
              />
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.sentLimits.title")}</div>
              <div className="sectionDesc">{t("settings.sections.sentLimits.desc.domain")}</div>
            </div>
            <div className="formsSectionSP">
              {areOutboundLimitsLoading ? (
                t("infoMsg.loading.limits")
              ) : (
                <RadioButton
                  className="inputFull2"
                  grouplabel={t("input.label.domain.limits.sending")}
                  children={outboundLimitOptions}
                  name="outbound_limit"
                  value={formData.outbound_limit}
                  onChange={this.alertIfIsPaidOption}
                  disabled={
                    isLoggedUserTrial ||
                    isWaitingPayment ||
                    (!loggedUser.can_edit_outbound_limits && !isLoggedUserAdmin)
                  }
                />
              )}

              {this.state.paidOptionSelected && (
                <div className={cx(s.payOptionMsg, "inputFull2")}>
                  <WarningBanner msg={t("infoMsg.payOption.invoice")} />
                </div>
              )}

              {(isLoggedUserTrial || isWaitingPayment) && (
                <div className={cx(s.payOptionMsg, "inputFull2")}>
                  <WarningBanner msg={t("infoMsg.disabledWhileWaitPaid")} info color="blue" />
                </div>
              )}
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.services.title")}</div>
              <div className="sectionDesc">
                <TranslatedString>settings.sections.services.desc.domain</TranslatedString>
              </div>
            </div>
            <div className="formsSectionSP">
              <Toggle
                className="inputFull2"
                label={t("input.label.access.pop")}
                name="pop_disabled"
                checked={formData.pop_disabled}
                errors={formErrors.pop_disabled}
                onChange={setFormFieldValue}
                reverse
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.access.imap")}
                name="imap_disabled"
                checked={formData.imap_disabled}
                errors={formErrors.imap_disabled}
                onChange={setFormFieldValue}
                reverse
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.access.smtp")}
                name="smtp_disabled"
                checked={formData.smtp_disabled}
                errors={formErrors.smtp_disabled}
                onChange={setFormFieldValue}
                reverse
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.access.webmail")}
                name="webmail_disabled"
                checked={formData.webmail_disabled}
                errors={formErrors.webmail_disabled}
                onChange={setFormFieldValue}
                reverse
              />

              {features.dav && (
                <Toggle
                  className="inputFull2"
                  label={t("input.label.access.dav")}
                  name="dav"
                  checked={formData.dav}
                  errors={formErrors.dav}
                  onChange={setFormFieldValue}
                />
              )}

              {features.activesync && (
                <Toggle
                  className="inputFull2"
                  label={t("input.label.access.active_sync")}
                  name="activesync"
                  checked={formData.activesync}
                  errors={formErrors.activesync}
                  onChange={setFormFieldValue}
                />
              )}

              {/*features.chat && (
                <Toggle
                  className="inputFull2"
                  label={t("input.label.access.chat")}
                  name="chat"
                  checked={formData.chat}
                  errors={formErrors.chat}
                  onChange={setFormFieldValue}
                />
              )*/}

              {/*features.meeting && (
                <Toggle
                  className="inputFull2"
                  label={t("input.label.access.meeting")}
                  name="meeting"
                  checked={formData.meeting}
                  errors={formErrors.meeting}
                  onChange={setFormFieldValue}
                />
              )*/}
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.catchAll.title")}</div>
              <div className="sectionDesc">{t("settings.sections.catchAll.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <div className="inputFull2"> {disabledCatchAllMessage}</div>
              <Toggle
                className="inputFull2"
                label={t("input.label.catchAll.enable")}
                name="catch_all_enabled"
                onChange={setFormFieldValue}
                checked={formData.catch_all_enabled}
                disabled={!hasloggedUserCatchallEnabled}
              />
              <Input
                className="inputFull2"
                label={t("input.label.catchAll.address")}
                placeholder={t("input.placeholder.email")}
                name="catch_all_destination"
                type="email"
                disabled={this.state.inputsDisabled || !formData.catch_all_enabled}
                onChange={setFormFieldValue}
                value={formData.catch_all_destination}
                errors={formErrors.catch_all_destination}
                required={!this.state.inputsDisabled}
              />
            </div>
          </div>
        </div>

        <Modal
          title={
            this.state.upgradeModalType === "professional"
              ? t("modal.planUpgradeProfessional.title")
              : t("modal.planUpgradeEnterprise.title")
          }
          closeModal={this.closeUpgradePlanModal}
          opened={this.state.isUpgradePlanModalOpened}
          onEnter={this.closeUpgradePlanModal}
        >
          <div>
            <Trans
              i18nKey={
                this.state.upgradeModalType === "professional"
                  ? "modal.planUpgradeProfessional.desc"
                  : "modal.planUpgradeEnterprise.desc"
              }
              components={{ listElement: <li className="ml-5" /> }}
            />
          </div>

          <div>
            <Button onClick={this.closeUpgradePlanModal} type="button" color="text">
              button.cancel
            </Button>

            <Button onClick={this.confirmUpgradePlan} type="button" color="green">
              button.changePlan
            </Button>
          </div>
        </Modal>

        <Modal
          title={
            this.state.warnModalType === "basic"
              ? t("modal.planDowngradeBasic.title")
              : t("modal.planDowngradeProfessional.title")
          }
          closeModal={this.closeWarnPlanModal}
          opened={this.state.isWarnPlanModalOpened}
          onEnter={this.closeWarnPlanModal}
        >
          <div>
            <Trans
              i18nKey={
                this.state.warnModalType === "basic"
                  ? "modal.planDowngradeBasic.desc"
                  : "modal.planDowngradeProfessional.desc"
              }
              components={{ listElement: <li className="ml-5" /> }}
            />
          </div>

          <div>
            <Button onClick={this.closeWarnPlanModal} type="button" color="text">
              button.cancel
            </Button>

            <Button onClick={this.confirmDowngradePlan} type="button" color="red">
              button.changePlan
            </Button>
          </div>
        </Modal>

        <Modal
          title={t("modal.paidOption.title")}
          closeModal={this.closeWarnModal}
          opened={this.state.isWarnModalOpened}
        >
          <div>
            <TranslatedString>modal.paidOption.desc</TranslatedString>
          </div>

          <div>
            <Button onClick={this.closeWarnModal} type="button">
              button.understood
            </Button>
          </div>
        </Modal>

        <Modal
          title={t("modal.cantDowngradeBasic.title")}
          closeModal={this.closeCantDowngradeBasic}
          opened={this.state.isCantDowngradeBasicOpened}
        >
          <div>
            <TranslatedString>modal.cantDowngradeBasic.desc</TranslatedString>
          </div>

          <div>
            <Button onClick={this.closeCantDowngradeBasic} type="button">
              button.understood
            </Button>
          </div>
        </Modal>
      </form>
    );
  }
}
